import axios from "axios";

const configuredBaseURL = process.env.VUE_APP_API_URL || "";

export const axiosInstance = axios.create({
    baseURL: configuredBaseURL,
    withCredentials: true, // Include cookies in requests
    headers: {
        'Content-Type': 'application/json'
    },
}); 
